<template>
  <!-- <ReservationHero v-if="websiteStatus == 1" /> -->

  <div class="landing">
    <HeroSection :auth="auth" :user="user" />
    <QuickAccessSection :auth="auth" />
    <GradesSection />
    <StatsSection />
    <TestimonialsSection :testimonials="testimonials" :loading="testimonialsLoading" />
    <MyTestimonialEditor
      v-if="auth"
      :my-testimonial="myTestimonial"
      @saved="onTestimonialSaved"
    />
    <CtaSection v-if="!auth" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';

import ReservationHero      from '@/components/home/ReservationHero.vue';
import HeroSection          from '@/components/home/HeroSection.vue';
import QuickAccessSection   from '@/components/home/QuickAccessSection.vue';
import GradesSection        from '@/components/home/GradesSection.vue';
import StatsSection         from '@/components/home/StatsSection.vue';
import TestimonialsSection  from '@/components/home/TestimonialsSection.vue';
import MyTestimonialEditor  from '@/components/home/MyTestimonialEditor.vue';
import CtaSection           from '@/components/home/CtaSection.vue';
import { useTestimonials }  from '@/composables/useTestimonials';

const store = useStore();

const websiteStatus = ref(localStorage.getItem('website_status') || 0);
const auth = ref(store.getters['isAuthenticated']);
const user = ref(JSON.parse(localStorage.getItem('user') || 'null'));

const {
  testimonials,
  testimonialsLoading,
  myTestimonial,
  fetchTestimonials,
  fetchMyTestimonial,
} = useTestimonials();

function onTestimonialSaved(updatedData) {
  myTestimonial.value = updatedData;
  fetchTestimonials();
}

onMounted(() => {
  fetchTestimonials();
  if (auth.value) fetchMyTestimonial();
});
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
.landing { font-family: 'Cairo', sans-serif; direction: rtl; overflow-x: hidden; }
</style>
